import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OwlCarousel from '../OwlCarousel/Carousel';

const CarouselTemplate = ({ media }) => (
  <img src={media.url} />
);

export default class PromotionCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      media: this.props.media,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ media: nextProps.media });
  }

  options() {
    return {
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      items: 1,
      dots: true,
      loop: true,
      nav: true,
      dotClass: 'promotion-group__dot',
      margin: 1,
      navText: [
        this.leftNavTextHtml(),
        this.rightNavTextHtml(),
      ],
    };
  }

  rightNavTextHtml() {
    return `
      <span class=" promotion-group__link--nav promotion-group__link--right">
        <a class="fa fa-chevron-right"></a>
      </span>
    `;
  }

  leftNavTextHtml() {
    return `
      <span class=" promotion-group__link--nav promotion-group__link--left">
        <a class="fa fa-chevron-left"></a>
      </span>
    `;
  }

  items() {
    return this.state.media.map((media, index) => (
      <CarouselTemplate
        key={index}
        media={media}
      />));
  }

  render() {
    return (
      <OwlCarousel
        options={this.options()}
      >
        {this.items()}
      </OwlCarousel>
    );
  }
}

PromotionCarousel.PropTypes = {
  media: PropTypes.array.required,
};



// WEBPACK FOOTER //
// ./src/Promotion/PromotionCarousel.js